import StudentGeneralInfo from './model';
import create from './create';

StudentGeneralInfo.create = create;

export default StudentGeneralInfo;



// WEBPACK FOOTER //
// ./data/AcademicInfo/StudentGeneralInfo/index.js